import React, { useEffect, useState, useRef } from "react";
import { Typography, Modal, Button, Input, Form, Select, Divider, Space, message, Tag, Tooltip } from "antd";
import { AuditOutlined, PlusCircleFilled } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { clientAction } from "../state/actions";
import { capitalizeFirst } from "../../Common/utils/extraFunctions";
import { v4 as uuidv4 } from "uuid";
import "../styles/RoleHashTag.css"
const RoleHashtags = ({ personDetails, setModelDrawer, selectedClient }) => {
    const { Text } = Typography;
    const dispatch = useDispatch();

    const [visible, setVisible] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [customTag, setCustomTag] = useState("");
    const inputRef = useRef();

    // Default options as array of objects (more flexible)
    const defaultOptions = [
        { id: uuidv4(), label: "MORTGAGE", value: "MORTGAGE" },
        { id: uuidv4(), label: "TITLE REP", value: "TITLE REP" },
        { id: uuidv4(), label: "CUSTOMER", value: "CUSTOMER" },
        { id: uuidv4(), label: "BUYER", value: "BUYER" },
        { id: uuidv4(), label: "SELLER", value: "SELLER" },
        { id: uuidv4(), label: "STAGER", value: "STAGER" },
        { id: uuidv4(), label: "PHOTOGRAPHER", value: "PHOTOGRAPHER" },
        { id: uuidv4(), label: "PROPERTY INSPECTOR", value: "PROPERTY INSPECTOR" },
        { id: uuidv4(), label: "INVESTOR", value: "INVESTOR" }
    ];

    const [options, setOptions] = useState(defaultOptions);

    useEffect(() => {
       
        let updatedOptions = [...defaultOptions];
    
        if (personDetails?.roleHashTags?.length) {
            for (let tag of personDetails.roleHashTags) {
                let exists = updatedOptions.find(opt => opt.value.toLowerCase() === tag.toLowerCase());
                if (!exists) {
                    updatedOptions.push({ id: uuidv4(), label: tag, value: tag });
                }
            }
        }
        setOptions(updatedOptions);
        setSelectedItems(personDetails?.roleHashTags || []);
    }, []);

    const showModal = () => setVisible(true);
    const handleCancel = () => {
        setVisible(false);
        setCustomTag("");
    };

    const normalize = (str) => str.trim().toLowerCase();

    const handleAddCustomTag = () => {
        const trimmed = customTag.trim();
        if (!trimmed) {
            message.warning("Tag cannot be empty!");
            return;
        }

        const capitalized = capitalizeFirst(trimmed);
        const duplicate = options.some(opt => normalize(opt.value) === normalize(capitalized));
        if (duplicate) {
            message.warning("Tag already exists!");
            return;
        }

        const newOption = { id: uuidv4(), label: capitalized, value: capitalized };
        setOptions(prev => [...prev, newOption]);
        setSelectedItems(prev => [...prev, capitalized]);
        setCustomTag("");
        inputRef.current?.focus();
    };

    const handleOk = () => {
        if (selectedItems.length === 0) {
            message.error("Please select or add a tag!");
            return;
        }
        dispatch(clientAction.updateRoleHashtags(selectedItems, personDetails?._id));
        setVisible(false);
    };

    return (
      <>
        <Text style={{ display: "flex", alignItems: "center" }}>
          <div className="roleContainer">
            <div className="roleIcon">
              <Tooltip title={"Tag"} placement="left">
                <AuditOutlined className="mainIcon" />
              </Tooltip>
            </div>

            <div style={{ fontSize: "18px", textTransform: "capitalize" }}>
              {!personDetails?.roleHashTags || personDetails?.roleHashTags?.length === 0 ? (
                "Add Tag"
              ) : (
                <span>
                  {personDetails?.roleHashTags?.map((tag) => (
                    <Tag key={tag} style={{ background: "rgb(8, 81, 145)", color: "white" }}>
                      {tag.toUpperCase()}
                    </Tag>
                  ))}
                </span>
              )}
            </div>

            <PlusCircleFilled style={{ color: "rgb(8, 81, 145)", fontSize: "1.5rem", marginRight: "0.9rem" }} className="roleBtn" onClick={showModal} />

            <Modal title={<span style={{ color: "rgb(61, 124, 183)", textDecoration: "underline" }}>Tag Details</span>} open={visible} footer={null} className="custom-modal" width={580} onCancel={handleCancel}>
              <Form>
                <Form.Item label="Tag" name="roleHashTags">
                  <Select
                    mode="multiple"
                    placeholder="Select or Add Tag"
                    value={selectedItems}
                    onChange={(value) => {
                  setSelectedItems(value);
                    }}
                    style={{ width: "100%" }}
                    dropdownRender={(menu) => (
                      <>
                        <div style={{ maxHeight: "200px", overflowY: "auto" }}>{menu}</div>
                        <Divider style={{ margin: "8px 0" }} />
                        <Space style={{ padding: "0 8px 4px", width: "100%" }}>
                          <Input
                            placeholder="Enter custom tag"
                            value={customTag}
                            ref={inputRef}
                            onChange={(e) => setCustomTag(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Backspace") {
                                e.stopPropagation();
                              }
                            }}
                            onPressEnter={handleAddCustomTag}
                            style={{ flex: 1 }}
                          />
                          <Button type="primary" disabled={!customTag} onClick={handleAddCustomTag}>
                            Add
                          </Button>
                        </Space>
                      </>
                    )}
                    options={options.map((opt) => ({
                      label: capitalizeFirst(opt.label),
                      value: opt.value,
                    }))}
                  />
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <Button type="primary" onClick={handleOk} disabled={!selectedItems.length}>
                      Done
                    </Button>
                    <Button onClick={handleCancel} style={{ marginLeft: "10px" }}>
                      Cancel
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </Modal>
          </div>
        </Text>
      </>
    );
};

export { RoleHashtags };
